// extracted by mini-css-extract-plugin
export var container = "Tooltip-module--container--55c87";
export var triangle = "Tooltip-module--triangle--dbe1c";